import { formatTime } from "@/utils/format/date-time";
import { Radio, Label } from "@headlessui/react";
import { CheckCircleIcon } from "@heroicons/react/20/solid";
import { cn } from "@/utils/cn";

export const TimeSlot = ({ value, available }) => {
    return (
        <Radio
            className={cn(
                "group relative flex shrink-0 cursor-pointer rounded-xl px-3 py-2 ring ring-gray-300 transition focus:outline-none data-checked:bg-darkgreen-500 data-checked:text-white data-checked:ring-darkgreen-500 data-focus:bg-darkgreen-400",
                !available &&
                    "cursor-default bg-neutral-100 text-neutral-400 ring-neutral-200",
            )}
            value={available ? value : ""}
            disabled={!available}
        >
            <Label className="text-sm select-none md:me-1">
                {formatTime(value)}
            </Label>
            <CheckCircleIcon className="ms-auto hidden size-5 fill-white opacity-0 transition group-data-checked:opacity-100 md:block" />
        </Radio>
    );
};
